import _ from "lodash";
import React, { PureComponent } from "react";
import { getNoOfQuestionsToConsiderForMarks, getPropertyValue } from "../../../../utils";
import { section } from "../../types/TestTemplateBody";
import {
  Grid,
  TableBody,
  Table,
  TableCell,
  TableRow,
  Link,
  Button,
  Typography,
} from "@material-ui/core";
import {
  CloseOutlined as CloseIcon,
  Launch as LaunchIcon,
  MoreVert as MoreIcon,
} from "@material-ui/icons";
import { MyPATPopMenu, MyPATSelect, MyPATTextField } from "../../../common";
import { QUESTION_TYPES } from "../../../../constants/comman";
import ACLService from "../../../acl/services/aclService";
import ControlPointIcon from "@material-ui/icons/ControlPoint";

enum QuestionAttemptType {
  OPTIONAL = "Optional",
  MANDATORY = "Mandatory",
}

interface Props {
  initialData?: section[];
  contentSubType: any[];
  courseSyllabusList: any[];
  showJEEMainSpecificFields?: boolean;
  onChange?: (section: section[]) => void;
  classes: any;
  isStandardTemplate?: boolean;
  isEditMode: boolean;
  isTemplateFromList?: boolean;
  onDone?: () => void;
  onCancel?: () => void;
  onSaveAsTemplate?: () => void;
  onEditAsTemplate?: () => void;
  onEdit?: () => void;
  onStandardTemplateSelect?: () => void;
  valid?: boolean;
  showMsg: Function;
  disabledCTAs?: boolean;
  showTestNameChanged?: boolean;
  updatedTestName?: string;
  UpdateNameOfTable?: boolean;
  tableName?: string;
  templateDetails?: any;
  templateChange?: any;
}

interface Row {
  sectionName: string;
  courseSyllabusId: string;
  subSectionName: string;
  quesCodeAllowed: number;
  positiveMarks: number;
  negativeMarks: number;
  partialMarks: number;
  noOfQuestions: number;
  totalMarks: number;
  partialMarksAllowed: boolean;
  sectionId: string;
  subSectionId: string;
  optionalQuestions?: boolean;
  mandatoryQuestionCount?: number;
  [key: string]: any;
}

interface State {
  rows: Row[];
  isValid: boolean;
  initialRows: Row[];
}

const EMPTY_ROW = {
  sectionName: "",
  subSectionName: "",
  quesCodeAllowed: -1,
  courseSyllabusId: "",
  positiveMarks: 0,
  negativeMarks: 0,
  partialMarks: 0,
  noOfQuestions: 0,
  totalMarks: 0,
  partialMarksAllowed: false,
  sectionId: "",
  subSectionId: "",
  optionalQuestions: false,
  mandatoryQuestionCount: 0,
};

// Input fields that cant have empty string value
const REQUIRED_INPUT_FIELDS = [
  "positiveMarks",
  "negativeMarks",
  "partialMarks",
  "noOfQuestions",
  "mandatoryQuestionCount",
];

class TestTemplateTable extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      rows: [],
      isValid: false,
      initialRows: [],
    };
    this.handleChange = _.debounce(this.handleChange, 200);
  }
  handleChange = (sections: section[]) => {
    if (this.props.onChange) {
      this.props.onChange(sections);
    }
  };
  resetRowsToInitial = () => {
    this.setState((prevState) => {
      return {
        ...prevState,
        rows: prevState.initialRows,
      };
    });
  };
  handleCancel = () => {
    const { onCancel } = this.props;
    if (onCancel) {
      onCancel();
      this.resetRowsToInitial();
    }
  };
  handleOnDone = () => {
    const { onDone, isStandardTemplate } = this.props;
    if (onDone) {
      onDone();
    }
    if (isStandardTemplate) {
      this.resetRowsToInitial();
    }
  };
  componentDidMount() {
    const { initialData: initial } = this.props;

    const initialData: section[] =
      initial && JSON.parse(JSON.stringify(initial));
    if (initialData) {
      const rows = initialData.reduce(
        (acc: Row[], { subSection, name: sectionName, courseSyllabusId }) => {
          const row: Partial<Row> = {
            sectionName:
              courseSyllabusId && courseSyllabusId.name
                ? courseSyllabusId.name
                : sectionName,
          };
          const subSectionData = subSection.reduce((acc: any, subS) => {
            const courseSyllabusIdOfSection = _.get(courseSyllabusId, "_id");
            const {
              name: subSectionName,
              positiveMarks,
              negativeMarks,
              partialMarksAllowed,
              noOfQuestions,
              partialMarks,
              optionalQuestions,
              _id: subSectionId,
              mandatoryQuestionCount,
              quesCodeAllowed,
            } = subS;

            acc.push({
              subSectionName,
              positiveMarks,
              negativeMarks,
              partialMarksAllowed,
              noOfQuestions,
              partialMarks,
              optionalQuestions,
              subSectionId,
              mandatoryQuestionCount,
              quesCodeAllowed,
              courseSyllabusId: courseSyllabusIdOfSection,
              totalMarks:
                getNoOfQuestionsToConsiderForMarks(subS) * positiveMarks,
            });

            return acc;
          }, []);
          const finalRowData = subSectionData.map((data: Partial<Row>) => ({
            ...data,
            ...row,
          }));
          acc = acc.concat(finalRowData);
          return acc;
        },
        []
      );
      this.setState({
        rows,
        initialRows: rows,
      });
    } else {
      this.initialiseEmptyRow();
    }
  }
  componentDidUpdate(prevProps: Props, prevState: State) {
    if (prevState.rows !== this.state.rows) {
      const isValid = this.validate();
      this.setState({
        isValid,
      });
      if (isValid) {
        const sections = this.combineRowsToSections();
        if (this.props.isEditMode) {
          this.handleChange(sections);
        }
      }
    }
  }
  combineRowsToSections = () => {
    const { rows } = this.state;

    const sections: { [sectionName: string]: section } = rows.reduce(
      (acc: { [sectionName: string]: section }, row) => {
        const { sectionName, sectionId, courseSyllabusId } = row;
        const subSection = this.createSubSectionFromRow(row);
        const questionCountForMarks = getNoOfQuestionsToConsiderForMarks(
          subSection
        );
        const subSectionMarks =
          subSection.positiveMarks * questionCountForMarks;
        if (acc[sectionName]) {
          acc[sectionName].subSection.push(subSection);
          acc[sectionName].totalMarks += subSectionMarks;
        } else {
          acc[sectionName] = {
            courseSyllabusId,
            autoPickSelection: false,
            totalMarks: subSectionMarks,
            subSection: [subSection],
            _id: sectionId,
            name: sectionName,
          };
        }
        return acc;
      },
      {}
    );

    return Object.values(sections);
  };
  onlyAllowNumbers = (
    evt: any,
    { allowNegative, currentValue } = { allowNegative: false, currentValue: "" }
  ) => {
    var theEvent = evt;
    var key = theEvent.keyCode || theEvent.which;
    key = String.fromCharCode(key);
    if (allowNegative) {
      if (key === "-" && !currentValue) {
        return;
      }
    }

    var regex = /[0-9]|\./;
    if (!regex.test(key)) {
      theEvent.returnValue = false;
      if (theEvent.preventDefault) theEvent.preventDefault();
    }
  };
  createSubSectionFromRow = (row: Row) => {
    const {
      subSectionName,
      quesCodeAllowed,
      negativeMarks,
      positiveMarks,
      partialMarksAllowed,
      noOfQuestions,
      partialMarks,
      subSectionId,
      optionalQuestions,
      mandatoryQuestionCount,
    } = row;
    return {
      name: subSectionName,
      quesCodeAllowed,
      negativeMarks,
      positiveMarks,
      partialMarksAllowed,
      noOfQuestions,
      partialMarks,
      instruction: "",
      _id: subSectionId,
      optionalQuestions,
      mandatoryQuestionCount,
    };
  };
  getTotalMarksOfAllRows = () => {
    const { rows } = this.state;
    return rows.reduce((acc, row) => {
      return (
        acc + row.positiveMarks * getNoOfQuestionsToConsiderForMarks(row as any)
      );
    }, 0);
  };
  getTotalQuestion = (rows: Row[]) => {
    const totalMarks = rows.reduce((acc, { noOfQuestions }) => {
      return acc + parseInt((noOfQuestions || 0).toString());
    }, 0);
    if (totalMarks > 500) {
      return (
        <MyPATPopMenu
          id="content-more-menu"
          icon={MoreIcon}
          menuItem="Question Limit Exceed"
        />
      );
    }
    return totalMarks;
  };

  getEmptyRow = () => {
    const { showJEEMainSpecificFields } = this.props;
    const newRow: Row = JSON.parse(JSON.stringify(EMPTY_ROW));
    // if (!showJEEMainSpecificFields) {
    //   delete newRow.optionalQuestions;
    //   delete newRow.mandatoryQuestionCount;
    // }
    return newRow;
  };
  initialiseEmptyRow = () => {
    this.setState((prevState) => {
      const newRow = this.getEmptyRow();
      return {
        ...prevState,
        rows: prevState.rows.concat(newRow),
      };
    });
  };
  handleAddSection = () => {
    this.setState((prevState) => {
      const newRows = [...prevState.rows];
      const newRow: Row = this.getEmptyRow();
      const lastRow = _.last(newRows) || { sectionName: "" };
      newRow.sectionName = lastRow.sectionName;
      newRows.push(newRow);
      return {
        ...prevState,
        rows: newRows,
      };
    });
  };
  handleAddSubSection = () => {
    this.setState((prevState) => {
      const newRows = [...prevState.rows];
      const newRow: Row = this.getEmptyRow();
      const lastRow = _.last(newRows) || { quesCodeAllowed: -1 };
      newRow.quesCodeAllowed = lastRow.quesCodeAllowed;
      newRows.push(newRow);
      return {
        ...prevState,
        rows: newRows,
      };
    });
  };
  handleChangeField = (value: any, fieldName: string, index: number) => {
    this.setState((prevState) => {
      const newRows = [...prevState.rows];
      const row = { ...newRows[index] };
      const oldValue = row[fieldName];

      if (
        fieldName === "mandatoryQuestionCount" &&
        value &&
        parseInt(value.toString()) > parseInt(row.noOfQuestions.toString())
      ) {
        return prevState;
      }
      row[fieldName] = value;

      // if(fieldName === 'noOfQuestions' && value && parseInt(value) > 500) {
      //   row[fieldName] = oldValue;
      //   this.props.showMsg("Question Limit Exceed", "error");
      // }

      let totalMarks = row.totalMarks;
      let sectionName = row.sectionName;
      let partialMarksAllowed = row.partialMarksAllowed;

      if (fieldName === "positiveMarks") {
        totalMarks =
          (parseInt(value) || 0) *
          getNoOfQuestionsToConsiderForMarks(row as any);
      } else if (
        fieldName === "noOfQuestions" &&
        row.mandatoryQuestionCount === undefined
      ) {
        totalMarks = (parseInt(value) || 0) * row.positiveMarks;
      } else if (fieldName === "courseSyllabusId") {
        const course = this.props.courseSyllabusList.find(
          ({ _id }) => _id === value
        );
        if (course) {
          sectionName = course.name;
        }
      } else if (fieldName === "partialMarks") {
        if (value && parseInt(value) > 0) {
          partialMarksAllowed = true;
        } else {
          partialMarksAllowed = false;
        }
      } else if (fieldName === "mandatoryQuestionCount") {
        totalMarks = (parseInt(value) || 0) * row.positiveMarks;
      }

      if (fieldName === "noOfQuestions" && row.optionalQuestions === false) {
        // if(value && parseInt(value) <= 500) {
        //   row.mandatoryQuestionCount = value;
        // } else if (!value) {
        //   row.mandatoryQuestionCount = value;
        // }
        row.mandatoryQuestionCount = value;
        totalMarks = (parseInt(value) || 0) * row.positiveMarks;
      } else if (fieldName === "noOfQuestions") {
        if (
          row.mandatoryQuestionCount !== undefined &&
          value < row.mandatoryQuestionCount
        ) {
          row.mandatoryQuestionCount = value;
        }
      }

      row.totalMarks = totalMarks;
      row.sectionName = sectionName;
      row.partialMarksAllowed = partialMarksAllowed;
      newRows[index] = row;

      if (fieldName === "noOfQuestions") {
        const totalQuestions = this.getTotalQuestion(newRows);
        if (totalQuestions > 500) {
          this.props.showMsg("Question Limit Exceed", "error");
        }
      }

      return {
        ...prevState,
        rows: newRows,
      };
    });
  };

  handleQuestionAttemptTypeChange = (
    questionAttemptType: QuestionAttemptType,
    index: number
  ) => {
    this.setState((prevState) => {
      const newRows = [...prevState.rows];
      const row = { ...newRows[index] };
      let optionalQuestions = row.optionalQuestions;
      let mandatoryQuestionCount = row.mandatoryQuestionCount;
      optionalQuestions =
        questionAttemptType === QuestionAttemptType.OPTIONAL ? true : false;
      mandatoryQuestionCount =
        questionAttemptType === QuestionAttemptType.MANDATORY
          ? row.noOfQuestions
          : row.mandatoryQuestionCount;
      row.optionalQuestions = optionalQuestions;
      row.mandatoryQuestionCount = mandatoryQuestionCount;
      newRows[index] = row;
      return {
        ...prevState,
        rows: newRows,
      };
    });
  };

  validate = () => {
    const { rows } = this.state;
    let isValid = true;
    for (let row of rows) {
      isValid = this.validateRow(row);
      if (!isValid) {
        break;
      }
    }
    const totalQuestions = this.getTotalQuestion(rows);

    if (totalQuestions > 500) {
      return false;
    }
    return isValid;
  };
  validateRow = (row: Row) => {
    for (let [fieldName, value] of Object.entries(row)) {
      // validations

      if (REQUIRED_INPUT_FIELDS.includes(fieldName) && value === "") {
        return false;
      }
      if (value && value.toString().trim().length === 0) {
        return false;
      }
      switch (fieldName) {
        case "sectionName": {
          if (value.trim().length === 0) {
            return false;
          }
          break;
        }
        case "subSectionName": {
          if (value.trim().length === 0) {
            return false;
          }
          break;
        }
        case "quesCodeAllowed": {
          if (value === -1) {
            return false;
          }
          break;
        }
        case "noOfQuestions": {
          if (value && value.toString() === "0") {
            return false;
          }
          break;
        }
        case "mandatoryQuestionCount": {
          if (value && value.toString() === "0") {
            return false;
          }
          break;
        }
        case "totalMarks": {
          if (value && value.toString() === "0") {
            return false;
          }
          break;
        }
        default:
          break;
      }
    }
    return true;
  };

  getQuestionTypeFromQuesCodeAllowed = (questionCodeAllowed: number) => {
    const content = this.props.contentSubType.find(
      ({ code }) => code.toString() === questionCodeAllowed.toString()
    );
    if (content) {
      return content.name;
    }
    return "";
  };

  getAllMandatoryQuestions = () => {
    const { rows } = this.state;
    return rows.reduce(
      (acc, { mandatoryQuestionCount, noOfQuestions }) =>
        acc +
        (mandatoryQuestionCount
          ? parseInt(mandatoryQuestionCount.toString()) || 0
          : (mandatoryQuestionCount === undefined ? noOfQuestions : 0)),
      0
    );
  };

  handleRemoveRow = (index: number) => {
    this.setState((prevState) => {
      const newRows = prevState.rows.filter((row, i) => i !== index);
      if (newRows.length === 0) {
        newRows.push(this.getEmptyRow());
      }
      return {
        ...prevState,
        rows: newRows,
      };
    });
  };

  render() {
    // Render your table here
    const { rows } = this.state;
    const {
      classes,
      templateDetails,
      templateChange,
      showJEEMainSpecificFields,
      isEditMode,
      showTestNameChanged,
      updatedTestName,
      UpdateNameOfTable,
      tableName = "Create New Format",
    } = this.props;
    return (
      <>
        {UpdateNameOfTable ? (
          <Typography style={{ textAlign: "left" }} variant="subtitle1">
            {updatedTestName}
          </Typography>
        ) : (
        <Grid container alignItems="center">
            <Grid item xs={8}>
              <Typography style={{ textAlign: "left" }} variant="subtitle1">
                <b>Template Name:</b> {tableName}
                {templateDetails && <span className={classes.durationTime}><b>Test Duration:</b> {templateDetails.testDurationNumber} mins</span>}
              </Typography>
            </Grid>
            <Grid item xs={4}>
              {templateChange}
            </Grid>
        </Grid>
        )}
        <Grid className={classes.overflowAuto}>
          <Table className={classes.detailsTable}>
            <TableBody>
              <TableRow className={classes.highlightedRow}>
                {isEditMode && <TableCell> </TableCell>}
                <TableCell
                  classes={{
                    root: isEditMode ? classes.thEditMode : classes.thViewMode,
                  }}
                >
                  <strong>
                    Section Name <br /> (Subjects)
                  </strong>
                </TableCell>
                <TableCell
                  classes={{
                    root: isEditMode ? classes.thEditMode : classes.thViewMode,
                  }}
                  // className={classes.thViewMode}
                >
                  <strong>
                    Sub section <br /> Name
                  </strong>
                </TableCell>
                {(
                  <>
                    <TableCell
                      classes={{
                        root: isEditMode
                          ? classes.thEditMode
                          : classes.thViewMode,
                      }}
                      // className={classes.thViewMode}
                    >
                      <strong>
                        Sub section <br /> Type
                      </strong>
                    </TableCell>
                  </>
                )}
                <TableCell
                  classes={{
                    root: isEditMode ? classes.thEditMode : classes.thViewMode,
                  }}
                  // className={classes.thViewMode}
                >
                  <strong>Type</strong>
                </TableCell>
                <TableCell
                  classes={{
                    root: isEditMode ? classes.thEditMode : classes.thViewMode,
                  }}
                  // className={classes.thViewMode}
                >
                  <strong>
                    Marking <br /> <span>(+ve)</span>{" "}
                  </strong>
                </TableCell>
                <TableCell
                  classes={{
                    root: isEditMode ? classes.thEditMode : classes.thViewMode,
                  }}
                  // className={classes.thViewMode}
                >
                  <strong>
                    Marking <br /> <span>(-ve)</span>{" "}
                  </strong>
                </TableCell>
                <TableCell
                  classes={{
                    root: isEditMode ? classes.thEditMode : classes.thViewMode,
                  }}
                  // className={classes.thEditMode}
                >
                  <strong>
                    Partial <br /> Marking
                  </strong>
                </TableCell>
                <TableCell
                  classes={{
                    root: isEditMode ? classes.thEditMode : classes.thViewMode,
                  }}
                  // className={classes.thEditMode}
                >
                  <strong>
                    Total Ques.
                    <br />
                    <span> (Max- 500)</span>
                  </strong>
                </TableCell>
                {(
                  <TableCell
                    classes={{
                      root: isEditMode
                        ? classes.thEditMode
                        : classes.thViewMode,
                    }}
                    // className={classes.thEditMode}
                  >
                    <strong>
                      Mandatory <br /> Ques.
                    </strong>
                  </TableCell>
                )}
                <TableCell
                  classes={{
                    root: isEditMode ? classes.thEditMode : classes.thViewMode,
                  }}
                  // className={classes.thEditMode}
                >
                  <strong>Marks</strong>
                </TableCell>
              </TableRow>
              {rows.map((row, index) => {
                return (
                  <>
                    <TableRow key={index}>
                      {isEditMode && (
                        <TableCell classes={{ root: classes.whiteBackground }}>
                          <span className={classes.centerImg}>
                            <img
                              src="/assets/svg/remove-circle.svg"
                              className={classes.rowDelete}
                              onClick={() => this.handleRemoveRow(index)}
                            />
                          </span>
                        </TableCell>
                      )}
                      <TableCell
                        classes={{
                          root: isEditMode
                            ? classes.whiteBackground
                            : classes.viewMode,
                        }}
                        // className={classes.viewMode}
                      >
                        {isEditMode ? (
                          <MyPATSelect
                            classes={{ input: classes.selectSection }}
                            label=""
                            inputId="courseSyllabusId"
                            value={row.courseSyllabusId}
                            onChange={(event: any) =>
                              this.handleChangeField(
                                event.target.value,
                                "courseSyllabusId",
                                index
                              )
                            }
                            name="courseSyllabusId"
                          >
                            <option
                              key="-1"
                              value=""
                              disabled
                              className={classes.greyText}
                            >
                              Select value
                            </option>
                            {_.map(
                              this.props.courseSyllabusList,
                              (cs, index) => {
                                return (
                                  <option
                                    key={`${cs._id} ${index}`}
                                    value={cs._id}
                                  >
                                    {cs.name}
                                  </option>
                                );
                              }
                            )}
                          </MyPATSelect>
                        ) : (
                          row.sectionName
                        )}
                      </TableCell>
                      <TableCell
                        classes={{
                          root: isEditMode
                            ? classes.whiteBackground
                            : classes.viewMode,
                        }}
                        // className={classes.viewMode}
                      >
                        {isEditMode ? (
                          <MyPATTextField
                            name="SubSection"
                            placeholder="Enter name"
                            customClasses={{
                              root: classes.textField,
                            }}
                            onChange={(event: any) =>
                              this.handleChangeField(
                                event.target.value,
                                "subSectionName",
                                index
                              )
                            }
                            value={
                              !_.isUndefined(row.subSectionName)
                                ? row.subSectionName
                                : ""
                            }
                          />
                        ) : (
                          row.subSectionName
                        )}
                      </TableCell>
                      {(
                        <>
                          <TableCell
                            classes={{
                              root: isEditMode
                                ? classes.whiteBackground
                                : classes.viewMode,
                            }}
                            // className={classes.viewMode}
                          >
                            {isEditMode ? (
                              <MyPATSelect
                                classes={{ input: classes.selectSection }}
                                label=""
                                inputId="questionAttemptType"
                                value={
                                  row.optionalQuestions
                                    ? QuestionAttemptType.OPTIONAL
                                    : QuestionAttemptType.MANDATORY
                                }
                                onChange={(event: any) =>
                                  this.handleQuestionAttemptTypeChange(
                                    event.target.value,
                                    index
                                  )
                                }
                                name="questionAttemptType"
                              >
                                <option value={QuestionAttemptType.MANDATORY}>
                                  Mandatory
                                </option>
                                <option value={QuestionAttemptType.OPTIONAL}>
                                  Optional
                                </option>
                              </MyPATSelect>
                            ) : row.optionalQuestions ? (
                              QuestionAttemptType.OPTIONAL
                            ) : (
                              QuestionAttemptType.MANDATORY
                            )}
                          </TableCell>
                        </>
                      )}

                      <TableCell
                        classes={{
                          root: isEditMode
                            ? classes.whiteBackground
                            : classes.viewMode,
                        }}
                        // className={classes.viewMode}
                      >
                        {isEditMode ? (
                          <MyPATSelect
                            label=""
                            inputId="questionType"
                            name="questionType"
                            onChange={(event: any) =>
                              this.handleChangeField(
                                event.target.value,
                                "quesCodeAllowed",
                                index
                              )
                            }
                            value={row.quesCodeAllowed}
                            classes={{ input: classes.questionTS }}
                          >
                            <option
                              value={-1}
                              disabled
                              className={classes.greyText}
                            >
                              Select value
                            </option>
                            {_.map(
                              this.props.contentSubType,
                              (questionType, index) => {
                                if (
                                  showJEEMainSpecificFields &&
                                  (questionType.code.toString() ===
                                    QUESTION_TYPES.PARAGRAPH.toString() ||
                                    questionType.code.toString() ===
                                      QUESTION_TYPES.DESCRIPTIVE.toString())
                                ) {
                                  return null;
                                }
                                return (
                                  <option
                                    key={`${questionType._id} ${index}`}
                                    value={questionType.code}
                                  >
                                    {questionType.name}
                                  </option>
                                );
                              }
                            )}
                          </MyPATSelect>
                        ) : (
                          this.getQuestionTypeFromQuesCodeAllowed(
                            row.quesCodeAllowed
                          )
                        )}
                      </TableCell>
                      <TableCell
                        classes={{
                          root: isEditMode
                            ? classes.whiteBackground
                            : classes.viewMode,
                        }}
                        // className={classes.viewMode}
                      >
                        {isEditMode ? (
                          <MyPATTextField
                            type="number"
                            value={row.positiveMarks}
                            onKeyPress={this.onlyAllowNumbers}
                            name="PositiveMarks"
                            inputProps={{
                              min: 0,
                            }}
                            customClasses={{
                              root: classes.textField,
                            }}
                            placeholder="Enter value"
                            onChange={(event: any) =>
                              this.handleChangeField(
                                event.target.value,
                                "positiveMarks",
                                index
                              )
                            }
                          />
                        ) : (
                          row.positiveMarks
                        )}
                      </TableCell>
                      <TableCell
                        classes={{
                          root: isEditMode
                            ? classes.whiteBackground
                            : classes.viewMode,
                        }}
                        // className={classes.viewMode}
                      >
                        {isEditMode ? (
                          <MyPATTextField
                            type="number"
                            name="NegativeMarks"
                            onKeyPress={this.onlyAllowNumbers}
                            customClasses={{
                              root: classes.textField,
                            }}
                            inputProps={{
                              min: 0,
                            }}
                            placeholder="Enter value"
                            onChange={(event: any) =>
                              this.handleChangeField(
                                event.target.value,
                                "negativeMarks",
                                index
                              )
                            }
                            value={row.negativeMarks}
                          />
                        ) : (
                          row.negativeMarks
                        )}
                      </TableCell>
                      <TableCell
                        classes={{
                          root: isEditMode
                            ? classes.whiteBackground
                            : classes.viewMode,
                        }}
                        // className={classes.viewMode}
                      >
                        {isEditMode ? (
                          <MyPATTextField
                            type="number"
                            name="PartialMarks"
                            onKeyPress={this.onlyAllowNumbers}
                            inputProps={{
                              min: 0,
                            }}
                            customClasses={{
                              root: classes.textField,
                            }}
                            placeholder="Enter value"
                            onChange={(event: any) =>
                              this.handleChangeField(
                                event.target.value,
                                "partialMarks",
                                index
                              )
                            }
                            value={row.partialMarks}
                          />
                        ) : (
                          row.partialMarks
                        )}
                      </TableCell>
                      <TableCell
                        classes={{
                          root: isEditMode
                            ? classes.whiteBackground
                            : classes.viewMode,
                        }}
                        // className={classes.viewMode}
                      >
                        {isEditMode ? (
                          <MyPATTextField
                            type="number"
                            name="NoofQuestion"
                            onKeyPress={this.onlyAllowNumbers}
                            customClasses={{
                              root: classes.textField,
                            }}
                            inputProps={{
                              min: 0,
                            }}
                            placeholder="Enter value"
                            onChange={(event: any) =>
                              this.handleChangeField(
                                event.target.value,
                                "noOfQuestions",
                                index
                              )
                            }
                            value={row.noOfQuestions}
                          />
                        ) : (
                          row.noOfQuestions
                        )}
                      </TableCell>
                      {(
                        <TableCell
                          classes={{
                            root: isEditMode
                              ? classes.whiteBackgroundLeft
                              : classes.viewMode,
                          }}
                          // className={classes.viewMode}
                        >
                          {isEditMode ? (
                            <MyPATTextField
                              type="number"
                              name="mandatoryQuestionCount"
                              onKeyPress={this.onlyAllowNumbers}
                              onChange={(event: any) =>
                                this.handleChangeField(
                                  event.target.value,
                                  "mandatoryQuestionCount",
                                  index
                                )
                              }
                              customClasses={{
                                root: classes.textField,
                              }}
                              inputProps={{
                                min: 0,
                                max: row.noOfQuestions,
                              }}
                              disabled={!row.optionalQuestions}
                              placeholder="Enter value"
                              value={
                                !_.isUndefined(row.mandatoryQuestionCount)
                                  ? row.mandatoryQuestionCount
                                  : ""
                              }
                            />
                          ) : (
                            row.mandatoryQuestionCount === undefined ? row.noOfQuestions : row.mandatoryQuestionCount
                          )}
                        </TableCell>
                      )}
                      <TableCell
                        style={{ paddingRight: "0" }}
                        classes={{
                          root: isEditMode
                            ? classes.whiteBackground
                            : classes.viewBackground,
                        }}
                      >
                        <div>{row.totalMarks}</div>
                      </TableCell>
                    </TableRow>
                  </>
                );
              })}
              {isEditMode ? (
                <TableRow>
                  <TableCell
                    classes={{
                      root: classes.whiteBackgroundLink,
                    }}
                  />
                  <TableCell
                    classes={{
                      root: isEditMode ? classes.whiteBackgroundLink : "",
                    }}
                  >
                    <Link
                      underline="always"
                      className="actionLink"
                      onClick={this.handleAddSection}
                    >
                      <ControlPointIcon />
                      &nbsp;Section
                    </Link>
                  </TableCell>
                  {/* <TableCell
                    classes={{
                      root: isEditMode ? classes.whiteBackgroundLink : "",
                    }}
                    colSpan={9}
                  >
                    <Link
                      underline="always"
                      className="actionLink"
                      onClick={this.handleAddSubSection}
                    >
                      <ControlPointIcon />&nbsp;Sub Section
                    </Link>
                  </TableCell> */}
                  <TableCell
                    colSpan={10}
                    classes={{
                      root: isEditMode ? classes.whiteBackgroundLink : "",
                    }}
                  />
                </TableRow>
              ) : null}

              <TableRow>
                {/* <TableCell
                  classes={{
                    root: isEditMode ? classes.whiteBackground : "",
                  }}
                  colSpan={3}
                /> */}
                <TableCell
                  align={"center"}
                  colSpan={
                      isEditMode
                        ? 8
                        : 7
                  }
                  classes={{
                    root: isEditMode ? classes.whiteBackgroundTotal : "",
                  }}
                >
                  <strong>Total</strong>
                </TableCell>

                {(
                  <>
                    {/* <TableCell
                      classes={{
                        root: isEditMode ? classes.whiteBackground : classes.viewBackground,
                      }}
                    /> */}
                    {/* <TableCell
                      classes={{
                        root: isEditMode ? classes.whiteBackground : "",
                      }}
                      colSpan={3}
                    /> */}
                    <TableCell
                      classes={{
                        root: isEditMode
                          ? classes.whiteBackground
                          : classes.viewBackground,
                      }}
                    >
                      <strong>{this.getTotalQuestion(this.state.rows)}</strong>
                    </TableCell>
                    <TableCell
                      classes={{
                        root: isEditMode
                          ? classes.whiteBackground
                          : classes.viewBackground,
                      }}
                    >
                      <strong>{this.getAllMandatoryQuestions()}</strong>
                    </TableCell>
                    <TableCell
                      style={{ paddingRight: "0" }}
                      classes={{
                        root: isEditMode
                          ? classes.whiteBackground
                          : classes.viewBackground,
                      }}
                    >
                      <strong>{this.getTotalMarksOfAllRows()}</strong>
                    </TableCell>
                  </>
                )}
                {/* {!showJEEMainSpecificFields && (
                  <>
                    <TableCell
                      classes={{
                        root: isEditMode
                          ? classes.whiteBackground
                          : classes.viewBackground,
                      }}
                    >
                      <strong>{this.getTotalQuestion(this.state.rows)}</strong>
                    </TableCell>
                    <TableCell
                      classes={{
                        root: isEditMode
                          ? classes.whiteBackground
                          : classes.viewBackground,
                      }}
                    >
                      <strong>{this.getTotalMarksOfAllRows()}</strong>
                    </TableCell>
                  </>
                )} */}
              </TableRow>
            </TableBody>
          </Table>
        </Grid>
        <br />
        <Grid
          container
          justify="flex-end"
          className={classes.tableActions}
          alignItems="center"
        >
          {/* {this.renderCTAs()} */}
        </Grid>
      </>
    );
  }

  renderCTAs = () => {
    const {
      isStandardTemplate,
      onSaveAsTemplate,
      onEditAsTemplate,
      classes,
      isTemplateFromList,
      isEditMode,
      valid = true,
      onEdit,
      onStandardTemplateSelect,
      disabledCTAs = false,
      showTestNameChanged,
    } = this.props;
    const { isValid } = this.state;
    const isDisabled = !isValid || !valid;

    if (isStandardTemplate) {
      return (
        <Grid container justify="flex-end" alignItems="center">
          {isEditMode && (
            <Link href="javascript:void(0)" onClick={this.handleCancel}>
              Cancel
            </Link>
          )}
          &nbsp;&nbsp;
          {!isEditMode && (
            <>
              <Button
                variant="outlined"
                color="primary"
                onClick={onEdit}
                disabled={
                  disabledCTAs ||
                  !ACLService.checkModulePermission("rule", "edit")
                }
                classes={{ root: classes.outlineTypeButton }}
              >
                Edit
              </Button>
            </>
          )}
          &nbsp;&nbsp;
          {isEditMode && (
            <Button
              variant="outlined"
              color="primary"
              onClick={onSaveAsTemplate}
              classes={{ root: classes.outlineTypeButton }}
              disabled={!isValid}
            >
              Save As template
            </Button>
          )}
          &nbsp;&nbsp;
          <Button
            variant="contained"
            color="primary"
            disabled={isDisabled || disabledCTAs}
            onClick={() => {
              if (isEditMode) {
                this.handleOnDone();
              } else {
                onStandardTemplateSelect && onStandardTemplateSelect();
              }
            }}
          >
            Done
          </Button>
        </Grid>
      );
    } else if (isTemplateFromList && isEditMode) {
      return (
        <Grid container justify="flex-end" alignItems="center">
          <Link href="javascript:void(0)" onClick={this.handleCancel}>
            Cancel
          </Link>
          &nbsp;&nbsp;
          <Button
            variant="contained"
            color="primary"
            disabled={isDisabled || disabledCTAs}
            onClick={this.handleOnDone}
          >
            Done
          </Button>
        </Grid>
      );
    } else if (isEditMode) {
      return (
        <Grid container justify="flex-end" alignItems="center">
          <Link href="javascript:void(0)" onClick={this.handleCancel}>
            Cancel
          </Link>
          &nbsp;&nbsp;
          {showTestNameChanged ? (
            <Button
              variant="outlined"
              color="primary"
              onClick={onEditAsTemplate}
              classes={{ root: classes.outlineTypeButton }}
              disabled={disabledCTAs}
            >
              Edit
            </Button>
          ) : (
            <Button
              variant="outlined"
              color="primary"
              onClick={onSaveAsTemplate}
              classes={{ root: classes.outlineTypeButton }}
              disabled={!isValid}
            >
              Save As template
            </Button>
          )}
          &nbsp;&nbsp;
          <Button
            variant="contained"
            color="primary"
            onClick={this.handleOnDone}
            disabled={isDisabled || disabledCTAs}
          >
            Done
          </Button>
        </Grid>
      );
    }
  };
}

export default TestTemplateTable;
